import { render, staticRenderFns } from "./topographic-subset-laboratory-grid.vue?vue&type=template&id=0c860abc&scoped=true&"
import script from "./topographic-subset-laboratory-grid.ts?vue&type=script&lang=ts&"
export * from "./topographic-subset-laboratory-grid.ts?vue&type=script&lang=ts&"
import style0 from "./topographic-subset-laboratory-grid.scss?vue&type=style&index=0&id=0c860abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c860abc",
  null
  
)

export default component.exports